import { IRejectionTreatment } from "./rejection-treatment";
import { ITransplantRejectionDSA } from "./transplant-rejection-dsa";
import { ITransplantRejectionBiopsy } from "./transplant-rejection-biopsy";

export interface IPostTransplantRejection {
    id: number,
    recipientId: number,
    dateOfRejection: Date,
    deNovoDsaPresent: number,
    persistentDsaPresent: number,
    deNovoDsaNonHla: boolean | null,
    persistentDsaNonHla: boolean | null,
    persistentDsaOther: boolean | null,
    persistentDsaOtherDetails: string,
    wasBiopsyPerformed: number | null,
    isDeleted: boolean,
    isDraft: boolean,
    treatments: IRejectionTreatment[],
    dsas: ITransplantRejectionDSA[],
    biopsy: ITransplantRejectionBiopsy
}